import { Maybe } from 'maybeasy';
import * as React from 'react';
import InvitationStore from '../../Store/InvitationStore';
import { InvitationResource } from '../../Store/Types';
import ModalStore from '../../../../../Modal/Store';
import { deactivateLink } from './DeactivateLink';
import { reactivateLink } from './ReactivateLink';

export interface Props {
  store: InvitationStore;
  resource: InvitationResource;
  modalStore: ModalStore;
}

export const actionItems = ({
  store,
  resource,
  modalStore,
}: Props): Array<Maybe<React.ReactNode>> => [
  deactivateLink({ store, resource, modalStore }),
  reactivateLink({ store, resource, modalStore }),
];
